// eslint-disable-next-line import/default
import FieldKit from 'field-kit';

// XXXX XXXXXX
const REGULAR = {
  delimiterMap: {},
  maximumLength: 11
};
export default class JpPhoneNumberFormatter extends FieldKit.PhoneFormatter {
  // TODO: move over to @square/phone-number
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    return text.replace(/\D+/g, '');
  }
  guessFormatFromText(text) {
    if (!text || typeof text === 'undefined') {
      super.guessFormatFromText(text);
      return;
    }
    this.delimiterMap = REGULAR.delimiterMap;
    this.maximumLength = REGULAR.maximumLength;
  }
}